const cities = [
  { name: "Auburn", zips: "36830, 36832, 36849" },
  { name: "Opelika", zips: "36801, 36803, 36804" },
  { name: "Phenix City", zips: "36867, 36868, 36869" },
  { name: "Alexander City", zips: "35010" },
  { name: "Tuskegee", zips: "36083" },
];

const benefits = [
  { icon: "ri-computer-line", title: "Start 100% Online", desc: "No office visit required to begin. Complete your order from your dorm, home, or office in minutes." },
  { icon: "ri-truck-line", title: "Ship Your Documents", desc: "Use overnight shipping to send your documents directly to us — we handle every detail from there." },
  { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays." },
  { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed." },
];

export default function AuburnLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white pt-6 md:pt-8 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Auburn &amp; East Alabama
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Auburn, Alabama occupies a unique position in the American South: it is a world-class research university town embedded in the heart of rural East Alabama. Auburn University's enrollment of over 30,000 students, combined with hundreds of faculty and research staff, creates a steady and consistent demand for international travel documents that few cities its size can match. Study-abroad semesters, international research collaborations, conference presentations in Europe and Asia, and graduate student exchanges with foreign institutions all generate passport needs that standard processing timelines cannot accommodate.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              The Auburn engineering and veterinary programs are particularly well-traveled — AU's College of Engineering sends students to internships and co-ops in Germany, Japan, and across Europe, while the College of Veterinary Medicine maintains international research partnerships and One Health collaborations in Africa and Latin America. These programs operate on academic calendars, not government processing schedules, which makes expedited passport service an essential resource for the AU community. A rejected application or standard processing delay can cost a graduate student an entire semester abroad.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Beyond the university, Auburn and surrounding Lee County are home to a growing professional community attracted by the city's quality of life. Opelika's manufacturing sector, including firms with international supply chains, sends engineers and plant managers on overseas trips with compressed booking windows. Phenix City's proximity to Columbus, Georgia adds cross-border professional travel needs. And Auburn's thriving retiree community — drawn by the university culture and smaller-city pace — maintains active travel schedules to Europe, the Mediterranean, and beyond.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              Fast Passport Center was built to serve travelers exactly like Auburn residents: people with real, pressing timelines who cannot afford the uncertainty of standard mail processing. We deliver the expedited, professional service that the Auburn community demands — with document review that catches errors before they derail a study-abroad semester, and processing as fast as 24 hours when a faculty member's European conference is next week.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Auburn, AL Service Area</p>
                  <p className="text-white/60 text-xs mt-0.5">Serving Lee County and surrounding East Alabama</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-5 leading-relaxed">
                After signing up online, ship your documents overnight to us from anywhere in Lee County. Most Auburn and Opelika clients use a prepaid label we provide — no office visit required for most services.
              </p>
              <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap">
                Start My Passport <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div key={i} className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md">
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    <span className="text-gray-400 text-xs font-mono hidden sm:inline">{city.zips}</span>
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in East Alabama — start online, ship overnight, and we handle the rest. No need to drive to Atlanta for a regional agency appointment.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[{ name: "Birmingham", href: "/birmingham" }, { name: "Montgomery", href: "/montgomery-al" }, { name: "Tuscaloosa", href: "/tuscaloosa" }, { name: "Huntsville", href: "/huntsville" }].map((link) => (
                    <a key={link.href} href={link.href} className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap">
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Auburn Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[{ icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" }, { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" }, { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" }, { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" }].map((item, i) => (
                  <div key={i} className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div>
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}